import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class BlobHelperService {
	open(blob: Blob): void {
		const downloadLink = document.createElement('a');
		downloadLink.target = '_blank';
		downloadLink.href = window.URL.createObjectURL(blob);
		document.body.appendChild(downloadLink);
		downloadLink.click();
		downloadLink.remove();
	}
}
